import { createTheme, Input, type MantineColorsTuple } from "@mantine/core";

const violetPalette: MantineColorsTuple = [
  "#f5f3ff", // violet.0 (50)
  "#ede9fe", // violet.1 (100)
  "#ddd6fe", // violet.2 (200)
  "#c4b5fd", // violet.3 (300)
  "#a78bfa", // violet.4 (400)
  "#8b5cf6", // violet.5 (500)
  "#7c3aed", // violet.6 (600)
  "#6d28d9", // violet.7 (700)
  "#5b21b6", // violet.8 (800)
  "#4c1d95", // violet.9 (900)
];

const darkPalette: MantineColorsTuple = [
  "#f1f0f5", // dark.0 - text
  "#9491a7", // dark.1 - dimmed text
  "#5a5a6e", // dark.2 - buttons/subtle borders
  "#3f3f50", // dark.3 - inputs/borders
  "#2d2d3d", // dark.4 - divider borders
  "#20202b", // dark.5 - hover bg
  "#16161f", // dark.6 - card/paper bg
  "#0a0a0f", // dark.7 - main body bg
  "#0a0a0f", // dark.8 - header/sidebar bg
  "#050508", // dark.9 - darkest bg
];

const theme = createTheme({
  fontFamily: "Inter, sans-serif",
  headings: {
    fontFamily: "Outfit, sans-serif",
  },
  primaryColor: "violet",
  colors: {
    violet: violetPalette,
    dark: darkPalette,
  },
  components: {
    Input: Input.extend({
      styles: {
        input: {
          fontSize: "16px",
        },
      },
    }),
  },
});

export default theme;
